import useAppointmentDetails from '@hooks/appointments/useAppointmentDetails';
import useAppointmentMeta from '@components/Clinicians/Session/hooks/useAppointmentMeta';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useRuntimeConfig } from '@vl-core/hooks/useConfig';

export const useHeidiEnabled = (appt_id: number) => {
  const { DISABLE_HEIDI_AI } = useRuntimeConfig();
  const { appointment: { audit_appt_id: auditApptId } = {} } = useSessionAppointment() ?? {};

  const activeApptId = auditApptId || appt_id;

  const { detailsCurrentAppointment } = useAppointmentDetails(activeApptId);
  const { data: appointmentsMeta } = useAppointmentMeta();
  if (!detailsCurrentAppointment) return;

  return (
    !DISABLE_HEIDI_AI &&
    !!detailsCurrentAppointment?.ai_notes_enabled &&
    !detailsCurrentAppointment?.ai_declined &&
    !!appointmentsMeta?.ai_notes
  );
};
